import InnerComponent from '@Components/Admin/Members';
import orgContainer from '@Components/AppContainer';

const MemberAdmin = () => ((orgContainer(InnerComponent)));
export default MemberAdmin;
